import Image from '@atoms/Image';
import type { ReactElement } from 'react';

import {
  Description,
  HeaderWrapper,
  ImageWrapper,
} from './AboutMeHeader.styled';
import type { AboutMeHeaderProps } from './AboutMeHeader.types';

export const AboutMeHeader = ({
  image,
  description,
}: AboutMeHeaderProps): ReactElement => (
  <HeaderWrapper>
    <ImageWrapper>
      <Image alt={image.alt} src={image.src as string} fill />
    </ImageWrapper>
    <h1>Cześć! 👋</h1>
    <Description>{description}</Description>
  </HeaderWrapper>
);
